var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1306 6.6306C71.1306 10.2905 68.1636 13.2612 64.5 13.2612C60.8364 13.2612 57.8694 10.2942 57.8694 6.6306C57.8694 2.967 60.8401 0 64.5 0C68.1599 0 71.1306 2.967 71.1306 6.6306Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M71.1306 122.369C71.1306 126.029 68.1636 129 64.5 129C60.8364 129 57.8694 126.033 57.8694 122.369C57.8694 118.706 60.8364 115.739 64.5 115.739C68.1636 115.739 71.1306 118.706 71.1306 122.369Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M122.369 71.1306C118.709 71.1306 115.739 68.1636 115.739 64.5C115.739 60.8364 118.706 57.8694 122.369 57.8694C126.033 57.8694 129 60.8364 129 64.5C129 68.1636 126.033 71.1306 122.369 71.1306Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.6306 71.1306C2.97069 71.1306 0 68.1636 0 64.5C0 60.8364 2.967 57.8694 6.6306 57.8694C10.2942 57.8694 13.2612 60.8364 13.2612 64.5C13.2612 68.1636 10.2942 71.1306 6.6306 71.1306Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M110.107 28.2657C107.52 30.8531 103.322 30.8531 100.731 28.2657C98.1432 25.6783 98.1432 21.4803 100.731 18.8893C103.318 16.3019 107.516 16.3019 110.107 18.8893C112.694 21.4766 112.694 25.6747 110.107 28.2657Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M28.2658 110.107C25.6784 112.694 21.4804 112.694 18.8893 110.107C16.2982 107.52 16.3019 103.322 18.8893 100.731C21.4767 98.1432 25.6747 98.1432 28.2658 100.731C30.8531 103.318 30.8531 107.516 28.2658 110.107Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M100.734 110.107C98.1469 107.52 98.1469 103.322 100.734 100.731C103.322 98.1432 107.52 98.1432 110.111 100.731C112.698 103.318 112.698 107.516 110.111 110.107C107.523 112.694 103.325 112.694 100.734 110.107Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M23.5775 30.2081C27.2395 30.2081 30.2081 27.2395 30.2081 23.5775C30.2081 19.9155 27.2395 16.9469 23.5775 16.9469C19.9155 16.9469 16.9469 19.9155 16.9469 23.5775C16.9469 27.2395 19.9155 30.2081 23.5775 30.2081Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.6294 13.4934C91.2362 16.8806 87.3625 18.4986 83.979 17.1054C80.5918 15.7122 78.9738 11.8385 80.367 8.45506C81.7602 5.06788 85.6339 3.44986 89.0174 4.84306C92.4045 6.23626 94.0226 10.1099 92.6294 13.4934Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.633 120.545C47.2398 123.932 43.3661 125.55 39.9826 124.157C36.5955 122.764 34.9774 118.89 36.3706 115.507C37.7638 112.119 41.6375 110.501 45.021 111.895C48.4082 113.288 50.0262 117.161 48.633 120.545Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.507 92.6294C112.119 91.2362 110.501 87.3625 111.895 83.979C113.288 80.5918 117.161 78.9738 120.545 80.367C123.932 81.7602 125.55 85.6339 124.157 89.0174C122.764 92.4045 118.89 94.0226 115.507 92.6294Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M8.45506 48.633C5.06788 47.2398 3.44986 43.3661 4.84306 39.9826C6.23626 36.5955 10.1099 34.9774 13.4934 36.3706C16.8806 37.7638 18.4986 41.6375 17.1054 45.021C15.7122 48.4082 11.8385 50.0262 8.45506 48.633Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.457 48.3234C117.077 49.7351 113.196 48.1392 111.784 44.7594C110.372 41.3796 111.968 37.4985 115.348 36.0869C118.728 34.6752 122.609 36.2712 124.021 39.651C125.432 43.0308 123.836 46.9118 120.457 48.3234Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.6482 92.9095C10.2684 94.3211 6.38729 92.7252 4.97566 89.3454C3.56404 85.9656 5.15995 82.0846 8.53975 80.6729C11.9196 79.2613 15.8006 80.8572 17.2122 84.237C18.6239 87.6168 17.028 91.4979 13.6482 92.9095Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.6766 120.457C79.265 117.077 80.8609 113.196 84.2407 111.784C87.6205 110.372 91.5015 111.968 92.9132 115.348C94.3248 118.728 92.7289 122.609 89.3491 124.021C85.9693 125.432 82.0882 123.836 80.6766 120.457Z",
    fill: "#52DE97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M36.0869 13.6482C34.6752 10.2684 36.2712 6.38729 39.651 4.97566C43.0308 3.56404 46.9118 5.15995 48.3234 8.53975C49.7351 11.9196 48.1392 15.8006 44.7594 17.2122C41.3796 18.6239 37.4985 17.028 36.0869 13.6482Z",
    fill: "#52DE97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2c700de307e9899c48a05f6214382d86.svg";
export { ForwardRef as ReactComponent };